<template>
  <div class="add-material">
    <div class="type-bar">
      <span class="type-label">类型</span>
      <el-radio-group v-model="materialType" class="type-radio">
        <el-radio :label="'TEMPLATE'">模版</el-radio>
        <el-radio :label="'STICKER'">贴纸</el-radio>
      </el-radio-group>
    </div>

    <div class="content">
      <component :is="currentComponent" :moduleId="moduleId" @close="handleClose" @success="handleCategoryData" />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import TemplateAddDataDialog from "@/views/college/templateMgmt/templateCategories/components/addDataDialog/index.vue";
import StickerAddDataDialog from "@/views/college/stickerMgmt/stickerCategories/components/addDataDialog/index.vue";

export default {
  name: "AddMaterial",
  components: {
    TemplateAddDataDialog,
    StickerAddDataDialog
  },
  props: {
    moduleId: {
      type: Number,
      default: null
    },
    // 对齐 galaxy：允许父级用 v-model 控制可见性（可选）
    addMaterialVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      materialType: "TEMPLATE",
      tabs: [
        { name: "TEMPLATE", component: "TemplateAddDataDialog" },
        { name: "STICKER", component: "StickerAddDataDialog" }
      ]
    };
  },
  computed: {
    currentComponent() {
      const found = this.tabs.find((t) => t.name === this.materialType);
      return found ? found.component : null;
    }
  },
  methods: {
    handleClose() {
      // 对齐 galaxy：支持 v-model:addMaterialVisible
      this.$emit("update:addMaterialVisible", false);
      this.$emit("close");
    },
    async handleCategoryData(data) {
      const selectedData = data && data.selectedData ? data.selectedData : [];
      const delSelectedData = data && data.delSelectedData ? data.delSelectedData : [];
      await Promise.all([
        selectedData.length
          ? api.addIndexConfigModulesResource(this.moduleId, {
            itemIds: selectedData.map((item) => item.id),
            resourceType: this.materialType
          })
          : Promise.resolve(),
        delSelectedData.length
          ? api.removeIndexConfigModulesResource(this.moduleId, {
            itemIds: delSelectedData.map((item) => item.id),
            resourceType: this.materialType
          })
          : Promise.resolve()
      ]);
      this.$message.success("操作成功");
      // 对齐 galaxy：成功后关闭弹窗
      this.$emit("update:addMaterialVisible", false);
      this.$emit("success");
    }
  }
};
</script>

<style scoped>
.add-material {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.type-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.type-label {
  font-weight: 700;
  font-size: 14px;
}

.type-radio {
  display: flex;
  align-items: center;
}

.content {
  margin-top: 16px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
</style>
